import PropTypes from 'prop-types';
import { Button, Card } from '@mui/material';
// ----------------------------------------------------------------------------------------------------------------

CancelButton.propTypes = {
    handleCancel: PropTypes.func,
};
// ----------------------------------------------------------------------------------------------------------------

const buttonStyle = {
    backgroundColor: 'common.white',
    color: 'common.black',
    border: '1.5px solid',
    borderColor: 'grey.300',
    mx: 1,
    ':hover': {
        backgroundColor: 'common.white',
        boxShadow: 10,
    }
}
// ----------------------------------------------------------------------------------------------------------------
export default function CancelButton({ handleCancel }) {

    return (
        <Button
            variant="contained"
            onClick={handleCancel}
            value={Card}
            sx={buttonStyle}
        >
            Cancel
        </Button>
    )
}